function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-265.5 -601.5)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  transform: "translate(266 602)",
  fill: "none",
  stroke: "#25a4b4",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(296.131 620.5) rotate(45)"
}, /*#__PURE__*/React.createElement("line", {
  x2: 10.791,
  y2: 0.001,
  transform: "translate(0 10.792) rotate(-90)",
  fill: "none",
  stroke: "#25a4b4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0H10.678",
  transform: "translate(0.001 0)",
  fill: "rgba(0,0,0,0)",
  stroke: "#25a4b4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
})), /*#__PURE__*/React.createElement("path", {
  d: "M0,0V20",
  transform: "translate(296 622.563)",
  fill: "rgba(0,0,0,0)",
  stroke: "#25a4b4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}));

var SvgUploadVideo = function SvgUploadVideo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUploadVideo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload-video.740fd1f7.svg";
export { ForwardRef as ReactComponent };